import classes from './GuestRooms.module.css'

import React from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { bookingActions } from '../../store/booking-slice'

import PlusMinusInput from '../UI/PlusMinusInput'

const GuestRooms = () => {
  const dispatch = useDispatch()

  const totalGuests = useSelector((state) => state.booking.totalGuests)

  const guestPlusClickHandler = () => {
    dispatch(bookingActions.setGuestPlusClicked({}))
  }

  const guestMinusClickHandler = () => {
    dispatch(bookingActions.setGuestMinusClicked({}))
  }

  const totalRooms = useSelector((state) => state.booking.totalRooms)

  const roomPlusClickHandler = () => {
    dispatch(bookingActions.setRoomPlusClicked({}))
  }

  const roomMinusClickHandler = () => {
    dispatch(bookingActions.setRoomMinusClicked({}))
  }

  //value
  //onMinusClick
  //onPlusClick

  // console.log(guestRoomsState)

  // const totalGuests = useSelector((state) => state.booking.totalGuests)
  // const totalRooms = useSelector((state) => state.booking.totalRooms)
  // console.log(totalGuests + ' < Guests | Rooms > ' + totalRooms)

  return (
    <div>
      <div className={`${classes.flexContainer}`}>
        <div className={`${classes.flexLabel} ${classes.guestsIcon}`}>
          <p className={classes.labelText}>Guests</p>
        </div>
        <div className={classes.flexContent}>
          <PlusMinusInput
            value={totalGuests}
            onMinusClick={guestMinusClickHandler}
            onPlusClick={guestPlusClickHandler}
          />
        </div>
      </div>

      <div className={`${classes.flexContainer}`}>
        <div className={`${classes.flexLabel} ${classes.accommodationIcon}`}>
          <p className={classes.labelText}>Rooms</p>
        </div>
        <div className={classes.flexContent}>
          <PlusMinusInput
            value={totalRooms}
            onMinusClick={roomMinusClickHandler}
            onPlusClick={roomPlusClickHandler}
          />
        </div>
      </div>
    </div>
  )
}

export default GuestRooms
